const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { canRefine, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.className =
      "button button--outline button--full-width list-toolbar__footer-button list-toolbar__footer-remove";
    button.textContent = "Remove";

    button.addEventListener("click", refine);

    widgetParams.container.insertAdjacentElement("afterbegin", button);
  }

  widgetParams.container.querySelector("button").disabled = !canRefine;
};

export const clearFacets =
  window.instantsearch.connectors.connectClearRefinements(
    renderClearRefinements
  );
